import { Component, OnInit, Inject, EventEmitter, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { OrderService } from '@app/shared/services/order/order.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';

@Component({
  selector: 'app-rating-review-dialog',
  templateUrl: './rating-review-dialog.component.html',
  styleUrls: ['./rating-review-dialog.component.css']
})
export class RatingReviewDialogComponent implements OnInit {
  saveData: any[] = [];
  dialogData !: any;
  IsUploadFile = true;
  createForm: FormGroup;
  reviewList !: any[];
  rateValue!: number;
  constructor(private dialogRef: MatDialogRef<RatingReviewDialogComponent>, private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any, private loader: LoaderService, private orderService: OrderService
    , private notification: NotificationService, private errorhandlerService: ErrorhandlerService) {
    this.createForm = this.formBuilder.group({
      ReviewDescription: [''],
      UserId: localStorage.getItem('userId'),
      ProductId: [''],
      CustomizedProductId: [''],
      OrderNumber: [''],
      RatingNumber: ['']
    });
    this.reviewList = [];
  }
  public event: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.createForm.patchValue({
      UserId: localStorage.getItem('userId'),
      ProductId: this.data.ProductId,
      CustomizedProductId: this.data.CustomizedProductId,
      OrderNumber: this.data.OrderNo,
      RatingNumber: event,
      ReviewDescription: ''
    });
    this.fn_getuserReview();
    this.dialogRef.afterClosed().subscribe((res: any) => {
      this.dialogData = res;
    });
  }

  onclose() {
    this.dialogRef.afterClosed().subscribe((res: any) => {
      this.dialogData = res;
    });
  }

  triggerEvent() {
    this.event.emit({ data: this.data });
  }

  fnratingvalue(event: any) {
    this.IsUploadFile = false;
    this.createForm.patchValue({
      // UserId: localStorage.getItem('userId'),
      // ProductId: this.data.ProductId,
      // CustomizedProductId: this.data.CustomizedProductId,
      // OrderNumber: this.data.OrderNo,
      RatingNumber: event
    });
  }

  saveReview(createForm: FormGroup): void {
    // const rev =  this.createForm.value;
    this.loader.show();
    this.orderService.AddOrderRatingReview(this.createForm.value).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.notification.success(res.Message, 'Success');
        this.loader.hide();
        // this.dialogRef.close();
        this.ngOnInit();
      } else if (res.StatusCode === 500) {
        this.notification.error(res.Message, 'Error');
        this.loader.hide();
      }
    }, (err: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  fn_getuserReview() {
    this.loader.show();
    this.orderService.getorderRatingReview(localStorage.getItem('userId'),
      this.data.OrderNo,
      this.data.ProductId).subscribe((res: any) => {
        if (res.StatusCode === 200) {
          if (res.Data.ResponseData !== null) {
            this.reviewList = [];
            this.reviewList = res.Data.ResponseData.ReviewList;
            // const totalRateValue =  res.Data.ResponseData.map((x: any) => (x.RateValue)).reduce((accumulator: any, currentValue: any) =>
            //                   accumulator + currentValue
            // );
            this.rateValue =  res.Data.ResponseData.Rating;
          } else {
            this.rateValue = 0;
          }
          this.createForm.patchValue({
            RatingNumber: this.rateValue
          });
          this.loader.hide();
        } else if (res.StatusCode === 500) {
          this.notification.error(res.Message, 'Error');
          this.loader.hide();
        }
      }, (err: any) => {
        this.loader.hide();
        this.errorhandlerService.handleError(err);
      });
  }
}
